import React, { Component } from "react";
import { Link } from "react-router-dom";
import { reduxForm } from "redux-form";
import Grid from "../../Utils/Grid";
import { canCreate, canEdit, canDelete, MODULES } from "../../../../utility/permissions";
import "./vehicle-types.css";
import Swal from 'sweetalert2';

class List extends Component {
    componentDidMount() {
        this.props.listar();
    }

    handleSearch = (e) => {
        if (this.props.searchChange) {
            this.props.searchChange(e.target.value);
        }
    };

    render() {
        const { listar, data, loader, onSortChange, searchChange, eliminar, me } = this.props;

        return (
            <div className="vehicle-types-page-container">
                {/* Header */}
                <div className="vehicle-types-page-header">
                    <div className="header-left">
                        <div className="title-section">
                            <h1>Tipos de Vehículos</h1>
                            <p className="subtitle">Listado General De Tipos De Vehículos</p>
                        </div>
                    </div>
                    <div className="header-actions">
                        {/* Only show create button if admin or has permission */}
                        {canCreate(me, MODULES.VEHICLE_TYPES) && (
                            <Link to="/vehicle-types/create" className="btn-vehicle-types-primary">
                                <span className="material-icons">add_circle_outline</span>
                                Crear Tipos de Vehículo
                            </Link>
                        )}
                    </div>
                </div>

                {/* Content Card */}
                <div className="vehicle-types-card">
                    {/* Search Bar - Right Aligned */}
                    <div className="vehicle-types-search-section">
                        <div className="vehicle-types-search-wrapper">
                            <input
                                type="text"
                                placeholder="Buscar"
                                onChange={this.handleSearch}
                            />
                            <span className="material-icons search-icon">search</span>
                        </div>
                    </div>

                    {/* Table using standardized Grid */}
                    <Grid
                        data={data}
                        loading={loader}
                        onPageChange={listar}
                        onSortChange={onSortChange}
                        columns={[
                            { dataField: "name", sort: true, text: "Nombre" },
                            { dataField: "nomenclature", sort: true, text: "Nomenclatura" },
                            {
                                dataField: "id",
                                text: "Acciones",
                                style: { width: '150px', textAlign: 'center' },
                                headerStyle: { textAlign: 'center' },
                                formatter: (cell) => (
                                    <div className="d-flex justify-content-center gap-2">
                                        <Link to={`/vehicle-type/${cell}`} className="btn-action-view" title="Ver">
                                            <span className="material-icons">visibility</span>
                                        </Link>
                                        {canEdit(me, MODULES.VEHICLE_TYPES) && (
                                            <Link to={`/vehicle-type/${cell}/editar`} className="btn-action-edit" title="Editar">
                                                <span className="material-icons">edit</span>
                                            </Link>
                                        )}
                                        {canDelete(me, MODULES.VEHICLE_TYPES) && (
                                            <button
                                                className="btn-action-delete"
                                                title="Eliminar"
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: '¿Estás seguro?',
                                                        text: "¡No podrás revertir esto!",
                                                        icon: 'warning',
                                                        showCancelButton: true,
                                                        confirmButtonColor: '#3085d6',
                                                        cancelButtonColor: '#d33',
                                                        confirmButtonText: 'Sí, eliminar',
                                                        cancelButtonText: 'Cancelar'
                                                    }).then((result) => {
                                                        if (result.value) {
                                                            eliminar(cell);
                                                        }
                                                    })
                                                }}
                                            >
                                                <span className="material-icons">delete</span>
                                            </button>
                                        )}
                                    </div>
                                )
                            }
                        ]}
                    />
                </div>
            </div>
        );
    }
}

export default reduxForm({
    form: "ListVehicleTypes",
})(List);
